// Segmented status tabs for list pages (styles in styles/list-header.scss, inside a `.list-v1` page).
// items: [{ id, label, count, tone?, color? }] — id null is "All"; `color` (hex from the API) overrides `tone`.
const StatusSegment = ({ items, activeId, onSelect, ariaLabel = "Filter by status" }) => (
  <div className="lv-seg" role="tablist" aria-label={ariaLabel}>
    {items.map((item) => {
      const isAll = item.id === null || item.id === undefined;
      const isActive = isAll
        ? activeId === null || activeId === undefined
        : String(activeId) === String(item.id);
      const style = item.color
        ? { "--lv-tone": item.color, "--lv-tone-soft": `${item.color}1f` }
        : undefined;

      return (
        <button
          key={isAll ? "all" : item.id}
          type="button"
          role="tab"
          aria-selected={isActive}
          className={`lv-seg-btn lv-tone-${item.tone || (isAll ? "navy" : "grey")} ${
            isActive ? "is-active" : ""
          }`}
          style={style}
          onClick={() => onSelect?.(isAll ? null : item.id)}
        >
          {!isAll && <span className="lv-seg-dot" />}
          {item.label}
          {item.count !== undefined && item.count !== null && (
            <span className="lv-seg-count">{item.count}</span>
          )}
        </button>
      );
    })}
  </div>
);

export default StatusSegment;
